import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import PropTypes from 'prop-types';
import { Grid, Column, Row, Button, HeaderCompound, cls, Heading } from '../../packages/components';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import './styles/AAFModalDeleteProfile.scss';

const AAFModalDeleteProfile = (props = {}) => {
  const {
    data: { data },
    deleteData,
    handleClose,
    callback,
  } = props;

  const p = {
    alwaysEnabled: true,
    aafNewStyle: true,
    className: 'aaf-modal',
    showLogo: true,
    yellowAction: () => props.handleClose(),
    colorButtons: [
      {
        content: Translator.get('top_head_option_button_back', 'REGRESAR'),
        props: {
          color: 'yellow',
          className: 'modal-button-return',
          imgSrc: Asset.get('top_head_option_back', ''),
          onClick: () => props.handleClose(),
        },
      },
    ],
  };
  return (
    <ModalWrapper {...p}>
      <Grid className="aaf-modal-delete-content">
        <Row className="aaf-modal-profile">
          <Column lg={12} className="aaf-modal-delete-title">
            <Heading size={1}>
              {Translator.get('deleteProfile_access_title_label', 'Eliminar Perfil')}
            </Heading>
          </Column>
          <Column lg={12}>
            <img
              src={data.user_image}
              className="aaf-modal-avatar-profile"
              alt="user_image"
            />
          </Column>
          <Column lg={12} className="aaf-modal-avatar-name">
            <span>{data.username}</span>
          </Column>
          <Column lg={12}>
            <p>
              {Translator.get(
                'deleteProfile_access_description_label',
                'Este perfil será eliminado y la información de Mis contenidos y actividad no podrá ser recuperada.'
              )}
            </p>
          </Column>
          <Column lg={12} className="aaf-modal-space-delete-profile">
            <Button
              activate
              type="button"
              className={cls('focusable', 'aaf-modal-delete-profile')}
              onClick={(e) => {
                deleteData();
                handleClose(e, callback);
              }}
            >
              {Translator.get(
                'deleteProfile_access_option_button_delete',
                'Eliminar perfil'
              )}
            </Button>
          </Column>
          <Column lg={12}>
            <Button
              activate
              type="button"
              className={cls('focusable', 'aaf-modal-cancel-profile')}
              onClick={(e) => {
                handleClose(e, callback);
              }}
            >
              {Translator.get(
                'deleteProfile_access_option_button_cancel',
                'Cancelar'
              )}
            </Button>
          </Column>
        </Row>
      </Grid>
    </ModalWrapper>
  );
};

AAFModalDeleteProfile.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
};

export default withOnClose(AAFModalDeleteProfile);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalDeleteProfile.jsx